import styles from './ReceiptStatus.module.scss';

export const ReceiptStatusWrapper = (props) => <div className={styles.wrapper} {...props} />;
